module.exports = __webpack_public_path__ + "img/qr_dy.5aed91ea.png";